import React from "react";
import Form from "./Form";
import { AddAssets } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";

function NewFacility(props) {
  const actionState = props?.location.state;
  const type = window.location.href.includes("update-") ? "Update" : "Add";

  const dispatch = useDispatch();
  return (
    <div>
      <Form
        pageName={`${type === "Update" ? "Update" : "New"} Facility`}
        assetType="Facility"
        state={actionState?.action}
        type={type}
      />
    </div>
  );
}

export default NewFacility;
